// extracted by mini-css-extract-plugin
module.exports = {"staffAccesImg":"styles_staffAccesImg__Yzer6"};